import React, { useState, useEffect } from 'react';

import BackDrop from '../../../shared/backdropDE';
import ErrorSnackbar from '../../error-snackbar';
import MuiAlert from '@mui/material/Alert';
import * as FileSaver from 'file-saver';
import { headersExportAbsenteeismSupport } from '../../../shared/constants-absenteeism';
import XLSXStyle from 'sheetjs-style';
import moment from 'moment';
import { getUser } from '../../../shared/auth-service';
import Checkbox from '@mui/material/Checkbox';

import {
    getColumns,
    getData,
    getAllAirports,
    getMonthsView,
    getDataExport
} from './logic';

import {
    Grid,
    Select,
    OutlinedInput,
    CircularProgress,
    Tooltip,
    Typography,
    MenuItem,
    InputLabel,
    FormControl,
    TextField,
    Box,
    Snackbar,
    Divider,
    FormControlLabel,
    Switch
} from "@mui/material";
import Fab from '@mui/material/Fab';
import { green } from '@mui/material/colors';
import CheckIcon from '@mui/icons-material/Check';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import BadgeIcon from '@mui/icons-material/Badge';
import DownloadIcon from '@mui/icons-material/Download';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useRef } from 'react';
import DataTable from '../../../shared/data-table';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AbsenteeismSupportConsult = () => {
    const user = getUser();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [employeeId, setEmployeeId] = useState('');
    const [startDate, setStartDate] = useState(new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1));
    const [endDate, setEndDate] = useState(new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0));
    const [base, setBase] = useState('');
    const [monthsView, setMontsView] = useState('');
    const [loadingRows, setLoadingRows] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [abbreviate, setAbbreviate] = useState(true);

    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [severetySnackBar, setSeveretySnackBar] = useState(false);
    const [messageSnackBar, setMessageSnackBar] = useState(false);

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const [columns, setcolumns] = useState([]);
    const [data, setData] = useState([]);
    const [airports, setAirports] = useState([]);

    const companyId = user.countryCode.split('-')[0];
    const company = user.countryCode.split('-')[1];
    const temporalId = user.temporalId;
    const [dateFilterType, setDateFilterType] = useState("FechaInicio");
    const hasFetchedData = useRef(false);

    useEffect(() => {
        if (hasFetchedData.current) return;
        const fetchData = async () => {
            if (loading) {
                try {


                    var data = await getData(QueryFilter());
                    var dataColumns = await getColumns(data);
                    var airportsData = [...user.airports];
                    setAirports(airportsData);

                    setcolumns(dataColumns);
                    setData(data);
                    setLoading(false);
                } catch (error) {
                    setError(error.message);
                    setLoading(false);
                }
            }
        };

        fetchData(); // Ejecuta la función fetchData
    }, []); // Lista de dependencias para `useEffect`

    const [successReload, setSuccessReload] = React.useState(false);
    const timer = React.useRef();
    const buttonSx = {
        ...(successReload && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    const [successExport, setSuccessExport] = React.useState(false);
    const buttonSxExport = {
        ...(successExport && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    const handleChangeStartDate = async (e) => {
        setStartDate(e);
        var MonthsView = await getMonthsView(e, endDate);
        setMontsView(MonthsView);

    };

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const handleChangeEndDate = async (e) => {
        setEndDate(e);
        var MonthsView = await getMonthsView(startDate, e);
        setMontsView(MonthsView);
        //console.log(MonthsView);
    };

    const handleReloadQuery_ORI = async () => {
        if (!loadingRows) {

            setSuccessReload(false);
            setLoadingRows(true);

            var MonthsView = await getMonthsView(startDate, endDate);
            setMontsView(MonthsView);

            var dataColumns = await getColumns(startDate, endDate);

            var data = await getData(QueryFilter());

            setcolumns(dataColumns);
            setData(data);

            setSuccessReload(true);
            setLoadingRows(false);

            timer.current = window.setTimeout(() => {
                setSuccessReload(false);
            }, 2000);
        }
    };

    const handleReloadQuery = async () => {
        if (!loadingRows) {
            setSuccessReload(false);
            setLoadingRows(true);

            var data = await getData(QueryFilter());
            var dataColumns = await getColumns(data);

            setcolumns(dataColumns);
            setData(data);

            setSuccessReload(true);
            setLoadingRows(false);

            timer.current = window.setTimeout(() => {
                setSuccessReload(false);
            }, 2000);
        }
    };

    const handleAbbreviatedChange = (event) => {
        setAbbreviate(event.target.checked);
    };


    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar(false);
    };

    function QueryFilter() {
        //console.log(dateFilterType);
        var paramsQuery = '';

        if (employeeId !== '' && employeeId != null) {
            paramsQuery = 'Employee=' + employeeId;
        }

        if (companyId !== '' && companyId != null) {
            paramsQuery = 'CompanyId=' + companyId;
        }

        if (temporalId !== '' && temporalId != null) {
            paramsQuery = 'TemporalId=' + temporalId;
        }

        if (base !== '' && base != null) {
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'AirportId=' + base;
        }

        if (startDate !== '' && startDate !== null) {
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'StartDate=' + formatDate(startDate);
        }

        if (endDate !== '' && endDate !== null) {
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'EndDate=' + formatDate(endDate);
        }

        if (abbreviate) {
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'Abbreviate=1';
        } else {
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'Abbreviate=0';
        }
        if (dateFilterType !== '' && dateFilterType != null) {
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'DateFilterType=' + dateFilterType;

        }

        paramsQuery = paramsQuery + '&' + 'employeeId=' + employeeId;

        paramsQuery = paramsQuery !== '' ? '?' + paramsQuery : paramsQuery;
        //console.log(paramsQuery);
        return paramsQuery;
    }

    function OpenMessage(message, severety) {
        setMessageSnackBar(message);
        setSeveretySnackBar(severety);
        setOpenSnackBar(true);
    };

    const handleExport = async () => {
        setLoadingExport(true);

        let rows = await getDataExport(QueryFilter());

        if (!rows || rows.length === 0) {
            OpenMessage("No hay datos para exportar", "warning");
            setLoadingExport(false);
            return;
        }

        // Extraer solo el texto de los encabezados
        const headers = headersExportAbsenteeismSupport.map(header => header.v);

        // Extraer solo los valores `v` de cada celda en `rows`
        const formattedRows = rows.map(row => row.map(cell => cell.v));
        const sheetData = [headers, ...formattedRows];

        const ws = XLSXStyle.utils.aoa_to_sheet(sheetData);

        // Aplicar estilos a los encabezados
        headers.forEach((_, colIndex) => {
            const cellAddress = XLSXStyle.utils.encode_cell({ r: 0, c: colIndex });
            if (!ws[cellAddress]) ws[cellAddress] = {};
            ws[cellAddress].s = {
                font: { bold: true },
                alignment: { horizontal: "center" }
            };
        });

        var fileName = "ReporteAusentismo_" + moment(new Date()).format('YYYYMMDDHHmmss');

        const wb = XLSXStyle.utils.book_new();
        XLSXStyle.utils.book_append_sheet(wb, ws, "data");

        const excelBuffer = XLSXStyle.write(wb, { bookType: "xlsx", type: "array" });
        const dataB = new Blob([excelBuffer], { type: fileType });

        FileSaver.saveAs(dataB, fileName + fileExtension);

        setSuccessExport(true);
        setLoadingExport(false);

        timer.current = window.setTimeout(() => {
            setSuccessExport(false);
        }, 2000);

        OpenMessage("Excel " + fileName + " exportado correctamente", "success");
    };



    if (loading) {
        return (<BackDrop />);
    }

    if (error) {
        return (<ErrorSnackbar message={error} />);
    }

    const getRowId = (row) => row.id;

    return (
        <>
            <Grid container spacing={2} >
                <Grid item xs={12}>
                    <Typography style={{ color: '#00B0EF', fontWeight: 'bold', fontSize: '24px' }}>
                        Historial soportes<span style={{ color: '#1A3072' }}> Ausentismos</span>
                    </Typography>
                </Grid>
                <Grid item>
                    <Grid container spacing={1} alignItems="center" wrap="nowrap">
                        <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                    label="Fecha Desde"
                                    inputFormat="DD/MM/YYYY"
                                    value={startDate}
                                    onChange={(e) => { setStartDate(e); handleChangeStartDate(e) }}
                                    renderInput={(params) => <TextField size='small' {...params} sx={{ minWidth: 120 }} />}
                                />
                                <DesktopDatePicker
                                    label="Fecha Hasta"
                                    inputFormat="DD/MM/YYYY"
                                    value={endDate}
                                    onChange={(e) => { setEndDate(e); handleChangeEndDate(e) }}
                                    renderInput={(params) => <TextField size='small' {...params} sx={{ minWidth: 120 }} />}
                                />
                            </LocalizationProvider>
                            <FormControl size="small" sx={{ minWidth: 100 }}>
                                <InputLabel id="base-label">Base</InputLabel>
                                <Select
                                    labelId="base-label"
                                    value={base}
                                    onChange={(e) => { setBase(e.target.value) }}
                                    label="Base"
                                >
                                    {airports.map(item => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.code}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined" size="small" sx={{ minWidth: 140 }}>
                                <InputLabel>Documento</InputLabel>
                                <OutlinedInput
                                    type={'text'}
                                    onChange={(e) => { setEmployeeId(e.target.value) }}
                                    endAdornment={<BadgeIcon />}
                                    label="Documento"
                                />
                            </FormControl>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={dateFilterType === "FechaInicio"}
                                        onChange={() => setDateFilterType("FechaInicio")}
                                        color="primary"
                                    />
                                }
                                label="Filtrar por Fecha de Inicio"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={dateFilterType === "FechaCreacion"}
                                        onChange={() => setDateFilterType("FechaCreacion")}
                                        color="primary"
                                    />
                                }
                                label="Filtrar por Fecha de Creación"
                            />

                            <Grid item xs={12} sm={3} md={2}>
                                <Box display="flex" alignItems="center">
                                    {/* Botón Filtrar */}
                                    <Tooltip title="Filtrar">
                                        <Box sx={{ position: 'relative', mr: 1 }}>
                                            <Fab size="small" color="primary" sx={buttonSx} onClick={handleReloadQuery}>
                                                {successReload ? <CheckIcon /> : <FilterAltIcon />}
                                            </Fab>
                                            {loadingRows && (
                                                <CircularProgress
                                                    size={48}
                                                    sx={{
                                                        color: green[500],
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        marginTop: '-24px',
                                                        marginLeft: '-24px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </Tooltip>

                                    {/* Exportar */}
                                    <Tooltip title="Exportar a Excel">
                                        <Box sx={{ position: 'relative', mr: 1 }}>
                                            <Fab size="small" color="primary" sx={buttonSxExport} onClick={handleExport}>
                                                {successExport ? <DownloadDoneIcon /> : <DownloadIcon />}
                                            </Fab>
                                            {loadingExport && (
                                                <CircularProgress
                                                    size={50}
                                                    sx={{ color: green[500], position: 'absolute', top: -4.9, left: -5, zIndex: 1 }}
                                                />
                                            )}
                                        </Box>
                                    </Tooltip>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Box sx={{ marginTop: 2 }} />
            <DataTable columns={columns} rows={data} getRowId={getRowId} />
            <Snackbar open={openSnackBar} autoHideDuration={4000} onClose={handleCloseSnackBar}>
                <Alert onClose={handleCloseSnackBar} severity={severetySnackBar} sx={{ width: '100%' }}>
                    {messageSnackBar}
                </Alert>
            </Snackbar>
        </>
    );
};

export default AbsenteeismSupportConsult;
